var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rebate" }, [
    _c("div", { staticClass: "rebate_header" }, [
      _c("div", { staticClass: "time_box" }, [
        _c("div", { staticClass: "time_header" }, [_vm._v("距离结算时间还有")]),
        _c("div", { staticClass: "time_content" }, [
          _c("i", [_vm._v(_vm._s(_vm.counterTime.hour[0]))]),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.hour[1]))]),
          _vm._v("时 "),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.min[0]))]),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.min[1]))]),
          _vm._v("分 "),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.sec[0]))]),
          _c("i", [_vm._v(_vm._s(_vm.counterTime.sec[1]))]),
          _vm._v("秒 "),
        ]),
      ]),
      _c("div", { staticClass: "rebate-info" }, [
        _c("div", { staticClass: "Accountflow" }, [
          _c("div", { staticClass: "tit" }, [_vm._v("昨日战力")]),
          _c("div", [
            _vm.user.rebate != null
              ? _c("span", { staticClass: "value" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("conversion")(_vm.user.rebate / 0.006)) +
                      " "
                  ),
                ])
              : _c(
                  "span",
                  { staticClass: "value", on: { click: _vm.loginbtnClick } },
                  [_vm._v("请登录")]
                ),
          ]),
        ]),
        _c("div", { staticClass: "Accountflow" }, [
          _c("div", { staticClass: "tit" }, [_vm._v("预计赠送")]),
          _c("div", [
            _vm.user.rebate != null
              ? _c("span", { staticClass: "value" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("conversion")(_vm.user.rebate)) + " "
                  ),
                ])
              : _c(
                  "span",
                  { staticClass: "value", on: { click: _vm.loginbtnClick } },
                  [_vm._v("请登录")]
                ),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.user.nickname,
              expression: "!user.nickname",
            },
          ],
          staticClass: "rebate-Mask",
          style: !_vm.user.nickname ? "opacity:1;" : "",
        },
        [
          _c("div", { staticClass: "end-img" }, [
            _c(
              "div",
              { staticClass: "viewDetail", on: { click: _vm.loginbtnClick } },
              [_vm._v("请登录")]
            ),
          ]),
        ]
      ),
    ]),
    _c("div", { staticClass: "rebate_desc_box" }, [
      _c("div", { staticClass: "event_rulebox" }, [
        _c("div", { staticClass: "title" }, [_vm._v("每日赠送激励比例")]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "rule_line" }, [
            _vm._v(" 当日累计消耗余额达到"),
            _c("span", { staticStyle: { color: "#827dff" } }, [_vm._v("1 ")]),
            _vm._v("以上，赠送累计消耗战力的"),
            _c("span", { staticStyle: { color: "#827dff" } }, [
              _vm._v(_vm._s(_vm.RebateRate) + "%"),
            ]),
            _vm._v("。 "),
          ]),
        ]),
      ]),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event_rulebox" }, [
      _c("div", { staticClass: "title" }, [_vm._v("优惠活动规则")]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "rule_line" }, [
          _vm._v(
            " 累计消耗计算：【开箱】【对战】和【升级】等任何形式的游戏战力额度，都计算每日激励。 "
          ),
        ]),
        _c("div", { staticClass: "rule_line" }, [
          _vm._v(" 结算方式：每日"),
          _c("span", { staticStyle: { color: "#827dff" } }, [_vm._v("19点")]),
          _vm._v("结算前一周期的累计激励奖励，结算周期为"),
          _c("span", { staticStyle: { color: "#827dff" } }, [
            _vm._v("每日19：00"),
          ]),
          _vm._v("至"),
          _c("span", { staticStyle: { color: "#827dff" } }, [
            _vm._v("次日18：59（以北京时间为准）"),
          ]),
          _vm._v("，自动赠送。 "),
        ]),
        _c("div", { staticClass: "rule_line" }, [
          _vm._v(" 注意：该奖励与“战力箱”的战力统计时间不一样。 "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }